import { apiService } from './api';

export interface RoleDefinition {
  id: string;
  key: string;
  label: string;
  color: string;
  sortOrder: number;
}

export interface PageDefinition {
  id: string;
  key: string;
  name: string;
  href: string;
  sortOrder: number;
}

export type RolePageConfigMap = Record<string, string[]>;

export const roleConfigService = {
  getRoles: async (): Promise<RoleDefinition[]> => {
    const res = await apiService.get<RoleDefinition[]>('/roles');
    return res.data;
  },

  getPages: async (): Promise<PageDefinition[]> => {
    const res = await apiService.get<PageDefinition[]>('/app-pages');
    return res.data;
  },

  createPage: async (page: Omit<PageDefinition, 'id'>): Promise<PageDefinition> => {
    const res = await apiService.post<PageDefinition>('/app-pages', page);
    return res.data;
  },

  updatePage: async (id: string, page: Partial<PageDefinition>): Promise<PageDefinition> => {
    const res = await apiService.put<PageDefinition>(`/app-pages/${id}`, page);
    return res.data;
  },

  deletePage: async (id: string): Promise<void> => {
    await apiService.delete(`/app-pages/${id}`);
  },

  getConfig: async (): Promise<RolePageConfigMap> => {
    const res = await apiService.get<RolePageConfigMap>('/role-page-config');
    return res.data;
  },

  saveConfig: async (config: RolePageConfigMap): Promise<RolePageConfigMap> => {
    const res = await apiService.put<RolePageConfigMap>('/role-page-config', config);
    return res.data;
  },
};
